import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Timestamp } from 'firebase/firestore';
import { useAuth } from '../../contexts/AuthContext';
import { saveReport } from '../../services/firestore';
import { reportConfigs } from '../../reports/reportConfigs';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

function ReportTypeSelectionDialog({ open, onClose }) {
  const [selectedValue, setSelectedValue] = useState('');
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  useEffect(() => {
    const firstEnabledReport = Object.values(reportConfigs).find(config => config.enabled);
    if (firstEnabledReport) {
      setSelectedValue(firstEnabledReport.id);
    }
  }, [open]);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleCreateReport = async () => {
    if (!currentUser) {
      console.error("No user logged in");
      // Handle user not logged in, maybe show a message
      return;
    }

    const reportConfig = reportConfigs[selectedValue];
    if (!reportConfig) {
      console.error("Invalid report type selected");
      return;
    }

    const initialData = {
      ...reportConfig.defaultValues(),
      reportType: selectedValue,
      userId: currentUser.uid,
      createdAt: Timestamp.now(),
      updatedAt: Timestamp.now(),
      status: 'in-progress',
      stepStatuses: {},
    };

    try {
      const reportId = await saveReport(initialData);
      const firstStepId = reportConfig.steps[0].id;
      navigate(`/${selectedValue}/${reportId}/${firstStepId}`);
      onClose();
    } catch (error) {
      console.error("Failed to create a new report:", error);
      // Handle error, maybe show a message to the user
    }
  };

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="report-type-dialog-title">
      <DialogTitle id="report-type-dialog-title">Select Report Type</DialogTitle>
      <DialogContent>
        <FormControl component="fieldset">
          <FormLabel component="legend">Choose the type of report you want to create:</FormLabel>
          <RadioGroup
            aria-label="report-type"
            name="report-type-radio-buttons-group"
            value={selectedValue}
            onChange={handleChange}
          >
            {Object.values(reportConfigs).filter(config => config.enabled).map(config => (
              <FormControlLabel
                key={config.id}
                value={config.id}
                control={<Radio />}
                label={config.name}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleCreateReport} autoFocus>
          Create Report
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ReportTypeSelectionDialog;